import { FUNNEL_TYPES } from "../utils/contants";
import { FunnelNavigationContext } from "../types";
import { useCallback, useEffect, useState } from "react";
import {
  EventTypes,
  publishViewedSubscriptionOfferEvent,
  publishViewedRegistrationEvent,
  publishViewedAlcOfferEvent,
} from "../../../screens/root/api/eventsApi";
import { rootComponentsStore } from "../../../hookstate/rootComponentsStore";

export function useFunnelNavigationContext(
  openFunnelType?: FUNNEL_TYPES,
  navigationContext?: FunnelNavigationContext,
) {
  useEffect(() => {
    if (navigationContext) {
      const queryParams = new URLSearchParams();
      Object.entries(navigationContext).forEach(([key, value]) => {
        if (key === "data" && typeof value === "object" && value !== null) {
          Object.entries(value).forEach(([dataKey, dataValue]) => {
            queryParams.append(toSnakeCase(dataKey), dataValue as string);
          });
        } else {
          queryParams.append(toSnakeCase(key), value);
        }
      });

      if (queryParams.size > 0) {
        rootComponentsStore.eventTrackingQueryParams.set(
          queryParams.toString(),
        );
      }
    } else {
      rootComponentsStore.eventTrackingQueryParams.set(undefined);
    }
  }, [navigationContext]);

  const sendEvent = useCallback(
    (eventType: EventTypes) => {
      if (navigationContext) {
        switch (eventType) {
          case EventTypes.viewed_subscription_offer:
        
          if (openFunnelType != FUNNEL_TYPES.offerPaywall) {
            publishViewedSubscriptionOfferEvent(navigationContext);
          }
            break;
          case EventTypes.viewed_registration:
            publishViewedRegistrationEvent(navigationContext);
            break;
          case EventTypes.viewed_alc_offer:
            publishViewedAlcOfferEvent({
              ...navigationContext,
              data: {
                ...navigationContext.data,
                hasSubscribeOffer: openFunnelType === FUNNEL_TYPES.prePaywall,
              },
            });
            break;
        }
      }
    },
    [navigationContext, openFunnelType],
  );

  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => setIsOpen(openFunnelType !== undefined), [openFunnelType]);
  useEffect(() => {
    if (isOpen && openFunnelType) {
      switch (openFunnelType) {
        case FUNNEL_TYPES.login:
        case FUNNEL_TYPES.signupEmailPassword:
        case FUNNEL_TYPES.signup:
          sendEvent(EventTypes.viewed_registration);
          break;
      }
    }
  }, [isOpen]);

  return sendEvent;
}

const toSnakeCase = (value: string): string =>
  value.replace(/([A-Z])/g, "_$1").toLowerCase();
